import { render, staticRenderFns } from "./QuotesModalSvg.vue?vue&type=template&id=4e18bd4a&scoped=true"
import script from "./QuotesModalSvg.vue?vue&type=script&lang=js"
export * from "./QuotesModalSvg.vue?vue&type=script&lang=js"
import style0 from "./QuotesModalSvg.vue?vue&type=style&index=0&id=4e18bd4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e18bd4a",
  null
  
)

export default component.exports